(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/views/partials/json-ld-scripttag.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/views/partials/json-ld-scripttag.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.emp_video_player=_cmps.emp_video_player||{};
_cmps.emp_video_player.templates=_cmps.emp_video_player.templates||{};
svs.components.emp_video_player.templates.json_ld_scripttag = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<script type=\"application/ld+json\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"jsonLDTags") || (depth0 != null ? lookupProperty(depth0,"jsonLDTags") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"jsonLDTags","hash":{},"data":data,"loc":{"start":{"line":1,"column":35},"end":{"line":1,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</script>\n";
},"useData":true});
Handlebars.partials['components-components-emp_video_player-json_ld_scripttag'] = svs.components.emp_video_player.templates.json_ld_scripttag;
})(svs, Handlebars);


 })(window);